import ListCaps from './views/List.vue'
import CreateEditCap from './views/CreateEdit.vue'
import GetCap from './views/Get.vue'

export const CapsRoutes = [
  {
    path: '/caps',
    name: 'ListCaps',
    component: ListCaps,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'cap:list'
    }
  },
  {
    path: '/cap',
    name: 'CreateCap',
    component: CreateEditCap,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'cap:create'
    }
  },
  {
    path: '/cap/:id',
    name: 'UpdateCap',
    component: CreateEditCap,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'cap:update'
    }
  },
  {
    path: '/cap/view/:id',
    name: 'GetCap',
    component: GetCap,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'cap:get'
    }
  }
]
